module.exports = __webpack_public_path__ + "img/赋码.df09f07a.svg";